import { useSelector } from "react-redux";
import QuoteRepository from "src/repository/QuoteRepository";
import {
    getSubmittedQuoteList,
    searchQuote,
    setIsSuccessAction,
    SetClearAllQuote,
    getOpenQuotesList,
} from "src/store/slice/model/OpenQuote";
import store from "src/storeWire";
import quoteDetailAPICallResponseMaker from "../service/reponseMaker/quoteDetailAPICallResponseMaker";
import {
    destroy_cart_quote_active_session,
    getLineItemsDetail,
    remove_quote_cart_line_item,
    select_all_quantity,
    toggle_quote_cart_line_item,
    clear_all_line_items,
    set_schedule_date
} from "src/store/slice/model/QuoteDetail";
import System from "src/helper/system";

export function useQuoteStore() {
    const openQuoteList = useSelector((state) => state.entities.model_OpenQuote.openQuoteList.records);
    const openQuoteCount = useSelector((state) => state.entities.model_OpenQuote.openQuoteList.count);
    const submittedQuoteList = useSelector((state) => state.entities.model_OpenQuote.submittedQuoteList);
    const searchQuoteList = useSelector((state) => state.entities.model_OpenQuote.searchQuoteList);
    const isSuccessAction = useSelector((state) => state.entities.model_OpenQuote.isSuccessAction);
    const statusList = quoteDetailAPICallResponseMaker.statusList;
    const quoteNumber = useSelector((state) => state.entities.model_QuoteDetail.quoteNumber);
    const cart_quote_active_session = useSelector((state) => state.entities.model_QuoteDetail.cart_quote_active_session);
    const line_items = useSelector((state) => state.entities.model_QuoteDetail.line_items);

    let data = {
        openQuoteList,
        submittedQuoteList,
        searchQuoteList,
        statusList,
        isSuccessAction,
        quoteNumber,
        line_items,
        cart_quote_active_session,
        openQuoteCount,

        get_current_quote_cart: () => {
            let quoteNumber = System.getParams().quote_number;
            if (quoteNumber && cart_quote_active_session && cart_quote_active_session[quoteNumber] && cart_quote_active_session[quoteNumber]?.records) {
                return cart_quote_active_session[quoteNumber].records;
            }
            return false;
        },
        get_selected_current_tab_data: (qtList, quoteCurentStatus) => {
            if (qtList && Object.entries(qtList).length > 0) {
                let data = {};
                let dataList = produceClone(qtList);
                Object.entries(dataList).map((v) => {
                    if (v[1].status && v[1].status === quoteCurentStatus) {
                        data[v[0]] = v[1];
                    }
                });
                return data;
            }
            return false;
        },
    };

    let fetch = {
        fetch_submitted_quote_list: async (params) => {
            return await store.dispatch(getSubmittedQuoteList(params))
        },
        fetch_search_quote_list: async (params) => {
            return await store.dispatch(searchQuote(params))
        },
        fetch_submitted_quote_export_url: async (params) => {
            return await new QuoteRepository().getSubmittedQuoteExportUrl(params)
        },
        get_RFQ_quantity: (product, priceList) => {
            return new QuoteRepository().getRFQMinQty(product, priceList);
        },
        add_open_quote: async (quote) => {
            return await new QuoteRepository().addOpenQuote(quote)
        },
        get_Dowpdown_List: async () => {
            return await new QuoteRepository().get_Dowpdown_List();
        },
        get_Project_Data: async () => {
            return await new QuoteRepository().get_Project_Data();
        },
        get_open_quote_list: async (params) => {
            return await store.dispatch(getOpenQuotesList(params));
        },
        fetch_line_items: async (params) => {
            return await store.dispatch(getLineItemsDetail(params))
        },
        set_SelectAll_Qty: async (quoteOrgList, qtList, quoteCurentStatus, productList) => {
            return await new QuoteRepository().setSelectAllQty(quoteOrgList, qtList, quoteCurentStatus, productList)
        },
    };
    let set = {
        clear_quote_list: async () => {
            return await store.dispatch(SetClearAllQuote())
        },
        clear_all_quote: async () => {
            return await new QuoteRepository().clearAllQuote();
        },
        single_delete_quote: async (lineItemId) => {
            return await new QuoteRepository().clearSingleQuote(lineItemId);
        },
        edit_quote_save: async (quoteData) => {
            return await new QuoteRepository().editQuoteSave(quoteData);
        },
        submit_quote: async (params) => {
            return await new QuoteRepository().submitQuote(params)
        },
        add_Update_Project_Data: async (params) => {
            return await new QuoteRepository().addUpdateProjectData(params)
        },
        add_multiple_quote: async (params) => {
            return await new QuoteRepository().addMultipleQuote(params)
        },
        set_is_success_action: async (params) => {
            return await store.dispatch(setIsSuccessAction(params))
        },
        send_submitted_quote_email: async (params) => {
            return await new QuoteRepository().sendSubmittedQuoteEmail(params)
        },
        toggle_quote_cart_line_item: (data) => {
            return store.dispatch(toggle_quote_cart_line_item({ data }))
        },
        destroy_cart_quote_active_session: () => {
            return store.dispatch(destroy_cart_quote_active_session())
        },
        remove_quote_cart_line_item: (data) => {
            return store.dispatch(remove_quote_cart_line_item(data))
        },
        select_all_quantity: (data) => {
            return store.dispatch(select_all_quantity(data))
        },
        set_schedule_date: (data) => {
            return store.dispatch(set_schedule_date(data))
        },

        clear_all_line_items: () => {
            return store.dispatch(clear_all_line_items())
        }
    };
    return [data, fetch, set]
}